/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-12 17:19:48
 * @Description: 新建用户
 */
"use strict";
angular.module("addOrEditTagModule", []).
controller("addOrEditTagCtrl", ["$scope", "$modalInstance","tagId","tagName","channelId","modalDialog","httpService", function($scope, $modalInstance,tagId,tagName,channelId,modalDialog,httpService) {
    initStatus();
	initData();
    function initStatus() {
        $scope.status = {
        	
        };
        $scope.data = {
        	id : tagId,
        	oldName : tagName,
        	tagName : tagName,
        }
    }
    function initData(){
    	requestData();
    }
    $scope.confirm = function() {
		if($scope.data.oldName != $scope.data.tagName){
			httpService.http("/mcnadmin/admin/tag/tagExistsValid.do",{tagName:$scope.data.tagName,tagId:0,channelId:channelId}, "post").then(function(data) {
				if(data.status === 'n'){
					modalDialog.alertType('','标签名已经存在','info')
				}else{
					$modalInstance.close($scope.data);
				}
			});
		}else{
			$modalInstance.close($scope.data);
		}
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
    function requestData(){
    }
    
}]);